import { render, staticRenderFns } from "./OperelInvoiceDimensions.vue?vue&type=template&id=efd801f4&scoped=true&"
import script from "./OperelInvoiceDimensions.vue?vue&type=script&lang=ts&"
export * from "./OperelInvoiceDimensions.vue?vue&type=script&lang=ts&"
import style0 from "./OperelInvoiceDimensions.vue?vue&type=style&index=0&id=efd801f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd801f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCombobox,VSimpleTable})
